import type { ValueOf } from 'type-fest';

export const ProjectSortPrefixes = {
  Licensing: 'issues-licensing',
  Total: 'issues-total',
  Security: 'issues-security',
  Quality: 'issues-quality',
  Title: 'title',
  LatestScan: 'latest-scan',
  LastAnalyzed: 'last-analyzed',
} as const;

export type ProjectSortPrefix = ValueOf<typeof ProjectSortPrefixes>;

export const TITLE_SORT = {
  ASC: `${ProjectSortPrefixes.Title}_asc`,
  DESC: `${ProjectSortPrefixes.Title}_desc`,
} as const;

export type TitleSort = ValueOf<typeof TITLE_SORT>;

export const TOTAL_ISSUES_SORT = {
  ASC: `${ProjectSortPrefixes.Total}_asc`,
  DESC: `${ProjectSortPrefixes.Total}_desc`,
} as const;

export type TotalIssuesSort = ValueOf<typeof TOTAL_ISSUES_SORT>;

export const LICENSING_ISSUES_SORT = {
  ASC: `${ProjectSortPrefixes.Licensing}_asc`,
  DESC: `${ProjectSortPrefixes.Licensing}_desc`,
} as const;

export type LicensingIssuesSort = ValueOf<typeof LICENSING_ISSUES_SORT>;

export const SECURITY_ISSUES_SORT = {
  ASC: `${ProjectSortPrefixes.Security}_asc`,
  DESC: `${ProjectSortPrefixes.Security}_desc`,
} as const;

export type SecurityIssuesSort = ValueOf<typeof SECURITY_ISSUES_SORT>;

export const QUALITY_ISSUES_SORT = {
  ASC: `${ProjectSortPrefixes.Quality}_asc`,
  DESC: `${ProjectSortPrefixes.Quality}_desc`,
} as const;

export type QualityIssuesSort = ValueOf<typeof QUALITY_ISSUES_SORT>;

export const LATEST_SCAN_SORT = {
  ASC: `${ProjectSortPrefixes.LatestScan}_asc`,
  DESC: `${ProjectSortPrefixes.LatestScan}_desc`,
} as const;

export type LatestScanSort = ValueOf<typeof LATEST_SCAN_SORT>;

export const LAST_ANALYZED_SORT = {
  ASC: `${ProjectSortPrefixes.LastAnalyzed}_asc`,
  DESC: `${ProjectSortPrefixes.LastAnalyzed}_desc`,
} as const;

export type LastAnalyzedSort = ValueOf<typeof LAST_ANALYZED_SORT>;

export type AnySort =
  TitleSort |
  TotalIssuesSort |
  LicensingIssuesSort |
  SecurityIssuesSort |
  QualityIssuesSort |
  LatestScanSort |
  LastAnalyzedSort;

// CommonSort applies to both projects and release groups.
type CommonSort = TitleSort | TotalIssuesSort | LatestScanSort;

export type ProjectsSort =
  CommonSort |
  LastAnalyzedSort |
  LicensingIssuesSort |
  SecurityIssuesSort |
  QualityIssuesSort;

export type ReleaseGroupsSort =
  CommonSort;

export const PROJECTS_SORT_OPTIONS: string[] = [
  ...Object.values(TITLE_SORT),
  ...Object.values(TOTAL_ISSUES_SORT),
  ...Object.values(LATEST_SCAN_SORT),
  ...Object.values(LAST_ANALYZED_SORT),
  ...Object.values(LICENSING_ISSUES_SORT),
  ...Object.values(SECURITY_ISSUES_SORT),
  ...Object.values(QUALITY_ISSUES_SORT),
];

export const RELEASE_GROUPS_SORT_OPTIONS: string[] = [
  ...Object.values(TITLE_SORT),
  ...Object.values(TOTAL_ISSUES_SORT),
  ...Object.values(LATEST_SCAN_SORT),
];
